//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CenterImg from "@/components/centerImg/centerImg.vue";
import LeftRedTitle from "@/components/leftRedTitle/leftRedTitle.vue";
export default {
  inject: ["showFooter", "switchHeaderStatus"],
  head() {
    return {
      script: [
        { src: 'https://hm.baidu.com/hm.js?bca287ea2f695c8758d364d29d58ef85' }
      ]
    }
  },
  data() {
    return {
      // 技术强项list
      strengthList: [
        {
          id: 4,
          title: "精密模具设计制造",
          hover: false,
          link: '/detail/jm',
          img: require("../assets/img/advnatage/strength_4.png"),
          descript: [
            "拥有40多年精密模具设计制造经验,我们能设计及制造各类塑胶模具设计、制造；是单色、双色及多色注塑模具、LSR冷流道注塑模具、LSR热流道注塑模具、固态硅胶射出冷流道模具、固态硅胶射出热流道模具、气辅成型模具、电木模具、硅胶按键模具、硅胶及橡胶杂件垫圈的生产专家。",
          ],
        },
        {
          id: 1,
          title: "医疗用品设计制造",
          hover: false,
          link: '/detail/yl',
          img: require("../assets/img/advnatage/strength_1.jpg"),
          descript: [
            "医疗级别模具设计制造，包含液态硅胶LSR模具及注塑双色模具及橡胶模具。",
            "医疗产品塑胶外壳注塑成型制造。",
            "液态硅胶LSR零件成型加工。",
          ],
        },
        {
          id: 2,
          title: "液态硅胶LSR成型技术",
          hover: false,
          link: '/detail/yt',
          img: require("../assets/img/advnatage/strength_2.png"),
          descript: [
            "拥有先进的液态硅胶 LSR 成型设备，成型硬度 0-80 度，最高精度可进行微量液态硅胶成型，为您提供更精致的包胶品质",
          ],
        },

        {
          id: 3,
          title: "双射及多色各类包胶技术",
          hover: false,
          link: '/detail/ss',
          img: require("../assets/img/advnatage/strength_3.png"),
          descript: [
            "我们有丰富的各类包胶技术及密封解决方案，我们专业的技术团队能解决客户各类包胶的技术需求及工程问题。",
          ],
        },
      ],
      strengthProductList: [
        {
          maskShow: false,
          src: require("../assets/img/detail/mj_1.jpg"),
          link: "/detail/mj",
          id: 1,
          title: "复合材料注塑成型",
          descript:
            "40年注塑产品制造经验,拥有丰富的各类注塑成型技术解决方案。我们是工程塑料应用科技解决商，专业应用各类工程塑料： PA.PC.POM.PBT.PPO.PPS.PI.PPS.PPSU.PEI.LCP等以及各类软胶注塑包胶：TPE.TPU.TPR.EPDM等",
        },
        {
          maskShow: false,
          src: require("../assets/img/detail/gt_5.png"),
          link: "/detail/gt",
          id: 2,
          title: "固态硅胶及合成橡胶应用",
          descript:
            "我们是硅胶应用科技解决商，拥有40年硅胶及合成橡胶生产经验；专业应用各类硅橡胶。",
        },
        {
          maskShow: false,
          src: require("../assets/img/detail/fs_1.jpg"),
          link: "/detail/fs",
          id: 3,
          title: "防水专家IP级防水方案",
          descript:
            "我们的工程技术研发中心,拥有专业的机构件IP防水工程师,能为客户进行DFM分析及提供最理想的防水方案,让客户在开模前做好工程设计评估,提高研发的试验效率。",
        },
        // {
        //   maskShow: false,
        //   src: require("../assets/img/advnatage/strength_8.png"),
        //   link: "/detail/mj",
        //   id: 4,
        //   title: "硅橡胶多色包胶成型",
        //   descript:
        //     "二十道复杂工艺,制造出的高端多色包 胶导电按键,匠心极品,美轮美奂.40 年的努力,积累无可匹敌的宝贵经验,",
        // },

        {
          maskShow: false,
          src: require("../assets/img/detail/js_1.jpg"),
          link: "/detail/js",
          id: 11,
          title: "金属包胶埋入成型",
          descript:
            "我们拥有数十年丰富的金属包胶埋入成型经验，能够制造精度高、品质优良的埋入成型产品。",
        },
        {
          maskShow: false,
          src: require("../assets/img/detail/fpc_1.png"),
          link: "/detail/fpc",
          id: 5,
          title: "FPC 触摸屏面板/薄膜开关研发制造",
          descript:
            "本公司设有多条薄膜开关、RTP触摸屏、PCBA及整机组装半自动生产线，能够承接工业、汽车电子、医疗设备及消费电子等行业的OEM特别是定制化接口零组件的设计到制造、及PCBA到整机产品的测试组装的一站式服务，方便快捷、性价比高。",
        },
        {
          maskShow: false,
          src: require("../assets/img/detail/bm_1.jpg"),
          link: "/detail/bm",
          id: 6,
          title: "表面处理应用",
          descript:
            "我们拥有非常优秀的表面处理技术,我们的洁净无尘车间,环境干净,品质优良。",
        },
        {
          maskShow: false,
          src: require("../assets/img/detail/dq_4.jpg"),
          link: "/detail/dq",
          id: 7,
          title: "氮气辅助注塑成型",
          descript:
            "拥有丰富专业的汽车零配件制造能力,从模具设计,到零件组装,提供一站式制造服务",
        },
        {
          maskShow: false,
          src: require("../assets/img/detail/yd_1.png"),
          link: "/detail/yd",
          id: 8,
          title: "液氮冷冻去毛边",
          descript:
            "我们拥有先进的冷冻去毛边设备,专业从事橡胶硅胶制品、锌铝镁合金合金压铸件、注塑（塑胶）制品去除毛边批锋作业。",
        },
        // {
        //   maskShow: false,
        //   src: require("../assets/img/advnatage/strength_13.png"),
        //   link: "/detail/g3d",
        //   id: 9,
        //   title: "快速模具3D打印技术",
        //   descript:
        //     "WIN Industry团队协助工程师进行制程前期DFM或设计分析, 导入3D打印技术,协助客户工程师印证机构强度及实物比例, 在设计中心,我们拥有多位专业的3D CAD/CAM高级工程师, 能为您提供更优质的打印品质,让您进行更准确的DFM机构分析.",
        // },
        {
          maskShow: false,
          src: require("../assets/img/advnatage/strength_14.png"),
          link: "/detail/g3d",
          id: 10,
          title: "高仿真材料3D打印",
          descript:
            "拥有先进的高仿真材料 3D 打印机,提供客户快速打样,或打印 3D 模仁做快速模具进行小批量生产,模拟实际产品的材料硬度及机构.",
        },
        {
          maskShow: false,
          src: require("../assets/img/detail/jmdzypzz_1.png"),
          link: "/detail/jmdzypzz",
          id: 12,
          title: "精密电子用品组装",
          descript:
            "我们具备整机精密电子用品组装能力，能按照客人需求提供整机组装；电子研发团队能满足客户的电子半成品研发，此外,我们拥有电子产品无尘组装车间，做到让客户在电子用品开发制造更省心省力。",
        },
      ],
      // 时间戳，用于鼠标移动的节流
      // timestamp: 0,
    };
  },
  mounted() {
    // 显示footer
    this.showFooter(true);
    this.switchHeaderStatus(true);
    this.fixLastFlex();
  },
  methods: {
    // 技术强项鼠标进入
    strenthMove(param) {
      this.strengthList.forEach((item) => (item.hover = false));
      param.hover = true;
    },
    // 技术强项鼠标离开
    strenthLeave(param) {
      param.hover = false;
    },
    // 产品选择鼠标进入
    advantageCardMove(param) {
      this.strengthProductList.forEach((item) => (item.maskShow = false));
      param.maskShow = true;
    },
    // 产品选择鼠标离开
    advantageCardLeave(param) {
      param.maskShow = false;
    },
    // 为最后一行flex左对齐
    fixLastFlex() {
      const length = this.strengthProductList.length;
      const resiue = length % 5;
      // console.log(length)
      /* 8 -> 9  7 ->  9   8/3=2--2 2+1 *3 9 9-length*/
      if (length !== 0 && resiue !== 0) {
        const rate = Math.floor(length / 5 + 1) * 5 - length;
        for (let i = 0; i < rate; i++) {
          this.strengthProductList.push({ temp: true });
        }
        console.log(this.strengthProductList.length);
      }
    },
    // 前往详情页面
    goDetailClick(param) {
      // this.$router.push(param.link);
      const {href} = this.$router.resolve(param.link)
      // window.open(location.pathname.replace(/(\/$)/, '') + href, '_blank')
      window.open(href, '_blank')
    },
  },

  components: {
    CenterImg,
    LeftRedTitle,
  },
};
